// Blog post metadata for the marketing blog. Kept in a standalone module so
// both the blog index and the landing "From the blog" section can import it
// without pulling in a page component (avoids any load-order issues).
//
// The earlier Local SEO / Google Business Profile articles were general SEO
// content, so they were moved to zoomlocal.in (our SEO management site). This
// fly-social.com blog is reserved for lead-gen-tool content: each post explains
// one of our free tools and routes the reader into it.
//
// Only the posts listed below are surfaced on /blogs. Older /blogs/<slug>
// routes still resolve in App.tsx on their own; they are simply not listed.
export interface BlogPostMeta {
  id: string;
  title: string;
  excerpt: string;
  readTime: string;
  publishDate: string;
  category: string;
  slug: string;
  featured?: boolean;
}

export const blogPosts: BlogPostMeta[] = [
  {
    id: "local-rank-checker",
    title: "Local Rank Checker: How to Track Your Business Position on Google Maps",
    excerpt: "See where your business actually appears on Google Maps across your target area. How a local rank checker reveals visibility gaps that manual searches hide.",
    readTime: "7 min read",
    publishDate: "Aug 18, 2026",
    category: "Local SEO Tools",
    slug: "/blogs/local-rank-checker",
    featured: true,
  },
  {
    id: "ai-visibility-checker",
    title: "AI Visibility Checker: How to See If Your Business Appears in AI Search",
    excerpt: "AI assistants now answer customer questions directly. Learn how to check whether your business appears in AI search results, and what influences it.",
    readTime: "7 min read",
    publishDate: "Aug 18, 2026",
    category: "AI Tools",
    slug: "/blogs/ai-visibility-checker",
  },
  {
    id: "google-reviews-analyzer",
    title: "Google Reviews Analyzer: Analyze Your Customer Reviews and Find Insights",
    excerpt: "Your star rating hides the real story. See how analyzing Google reviews reveals what customers consistently praise, and what quietly costs you business.",
    readTime: "7 min read",
    publishDate: "Aug 18, 2026",
    category: "Reputation",
    slug: "/blogs/google-reviews-analyzer",
  },
  {
    id: "seo-site-audit",
    title: "How to Perform an SEO Site Audit for Better Google Rankings",
    excerpt: "A practical walkthrough of an SEO site audit: what to check, what the results mean, and which fixes actually move rankings.",
    readTime: "7 min read",
    publishDate: "Aug 18, 2026",
    category: "SEO",
    slug: "/blogs/seo-site-audit",
  },
  {
    id: "google-business-profile-audit-improve-local-rankings",
    title: "How a Google Business Profile Audit Tool Helps Businesses Improve Local Rankings",
    excerpt: "A Google Business Profile audit shows what is holding your local rankings back, from categories and services to reviews, photos and competitor gaps.",
    readTime: "7 min read",
    publishDate: "Aug 18, 2026",
    category: "Profile Optimization",
    slug: "/blogs/google-business-profile-audit-improve-local-rankings",
  },
  {
    id: "generate-local-seo-leads-free-audit-tools",
    title: "How Digital Marketing Agencies Can Generate More Local SEO Leads with Free Audit Tools",
    excerpt: "Free SEO audit tools let agencies prove their value before the first sales call. See how embedding Local SEO and Google Business Profile audits on your website turns visitors into qualified local SEO leads.",
    readTime: "8 min read",
    publishDate: "Jul 31, 2026",
    category: "Agency Guide",
    slug: "/blogs/generate-local-seo-leads-free-audit-tools",
  },
];
